import React, { useContext, useEffect, useRef, useState } from 'react';
import './index.css';
import { Button, Form, Input, Popconfirm, Table, Typography, DatePicker, Space, message, Col, Row} from 'antd';
import PageWrapper from "../../helpers/PageWrapper";
import moment from 'moment';
import { DeleteTwoTone, DownloadOutlined, EditTwoTone } from '@ant-design/icons';
import styles from './style.module.css';
import axios from 'axios';
import { useParams } from 'react-router';
import TokenService from "../../../services/token.service";
import authAxios from "../../../services/api";
import { notification } from 'antd';
import { TableOutlined } from "@ant-design/icons";
const LessonPlanPage = () => {
  const [lessons, setLessons] = useState([]);
  const { teacherId, streamId } = useParams();
  
  // let studyHours = "2"
  // if (teacherId == 25 || teacherId == 24 || teacherId == 26){ studyHours = "6"}
    


  useEffect(() => {
    
    
    authAxios.get(`http://85.159.27.198:8080/abitur/api/v1/teacher/${teacherId}/streams/${streamId}/lessons?sortbydate=true`,{

      headers: {
          'Authorization': 'Bearer ' + TokenService.getLocalAccessToken(),
      }
  })
      .then((response) => {
        setLessons(response.data);
        console.log(lessons)
      })
      .catch((err) => {
        console.log(err.message);
      });
  }, []);
  const mergeArrays = (arr1) => {
    return arr1.map((lesson) => {
      return lesson;
    });
  };

  const mergedArrays = mergeArrays(lessons)
  console.log(mergedArrays)
  const [dataSource, setDataSource] = useState(
    [

      lessons.map(lesson => ({
        key: lesson.id,
        date: lesson.date,
        studyHours: '2',
        theme: lesson.theme,
        homeWork: lesson.desc,
      }))

    ]);
  const [count, setCount] = useState(2);



  const defaultColumns = [
    {
      title: "Дата проведения занятия",
      dataIndex: "date",
      width: "15%",
      key: "date",
      render: (_, record) => (
        <DatePicker value={moment(record.date)} format="DD-MM-YYYY" />
      ),
    },
    {
      title: "Количество учебных часов",
      dataIndex: "studyHours",
      width: "15%",
    },
    {
      title: "Тема Занятия",
      dataIndex: "theme",
      editable: true,
    },
    {
      title: "Что задано",
      dataIndex: "homeWork",
      editable: true,
    },
    {
      title: "operation",
      dataIndex: "operation",
      width: "10%",
      key: "theme",
      render: (_, record) =>
      
        <Space size="middle">
          
            <Popconfirm placement="topLeft" title={'Вы действительно хотите удалить этот урок?'} onConfirm={() => handleDeleteLesson(record.id)} okText="Yes" cancelText="No">
          <Button className={styles.deleteButton} >
            <DeleteTwoTone twoToneColor="#ff0000"  />
          </Button>
          </Popconfirm>
          

          <Button href={`/lesson-update-page/edit/teacherId/${teacherId}/stream-id/${streamId}/${record.id}`}>
            <EditTwoTone />
          </Button>

        </Space>
        
    },
  ];

  const handleDeleteLesson = (key) => {
    axios.delete(`http://85.159.27.198:8080/abitur/api/v1/teacher/${teacherId}/streams/${streamId}/lessons/delete?lessonId=${key}`,{
      method: 'GET',
      headers: {
          'Authorization': 'Bearer ' + TokenService.getLocalAccessToken(),
      }
  })
      .then(res => {
        
        console.log(res);
        console.log(res.data);
        message.success('Урок удален', 10);
        authAxios.get(`http://85.159.27.198:8080/abitur/api/v1/teacher/${teacherId}/streams/${streamId}/lessons?sortbydate=true`,{

      headers: {
          'Authorization': 'Bearer ' + TokenService.getLocalAccessToken(),
      }
  })
      .then((response) => {
        setLessons(response.data);
        console.log(lessons)
      })
      .catch((err) => {
        console.log(err.message);
      });
      }).catch((error) =>  message.error(error, 10));

      
  };

  const columns = defaultColumns.map((col) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
       
      }),
    };
  });

  const exportLessonsList = () => {
    return authAxios({
      url: `http://85.159.27.198:8080/abitur/api/v1/document/get-lesson-document?stream-id=${streamId}`,
      method: 'GET',
      responseType: 'blob',
      headers: {
        'Authorization': 'Bearer ' + TokenService.getLocalAccessToken(),
    }
    }).then((response) => {
      console.log(response);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `lesson${streamId}.pdf`);
      document.body.appendChild(link);
      link.click();

  
    })
     
  };
  return (
    <PageWrapper>
      
      <Typography.Title level={1}>Список Учебных Тем</Typography.Title>
      <Row>
        <Col flex="auto"></Col>
        <Col flex={0}>
          <Space style={{ marginBottom: 20 }}>
          <a href={`/lesson-create-page/teacherId/${teacherId}/stream-id/${streamId}`} >
        <Button type="primary" > Добавить новый урок
        </Button>
      </a>
      <a href={`/exam-create-page/stream-id/${streamId}`} >
        <Button type="primary" > Добавить экзамен
        </Button>
      </a>
      <Button variant="warning"  onClick={exportLessonsList}icon={<TableOutlined />}
            >
              Экспортировать журнал
        </Button>
          </Space>
        </Col>
      </Row>
     
      
      
            
      <Table
        id="table-to-xls"
        rowClassName={() => 'editable-row'}
        bordered
        dataSource={mergedArrays.map((lesson) => ({
          id: lesson.id,
          theme: lesson.theme,
          homeWork: lesson.desc,
          studyHours: lesson.hour,
          date: lesson.date,
        }))}
        columns={columns}
      />
    </PageWrapper>
  );
};

export default LessonPlanPage;
